export default "__VITE_ASSET__BnzUCq7A__"